import { useId } from 'react';

type Props = {
  width?: number;
  height?: number;
};

export function Logo({ width = 26, height = 22 }: Props) {
  const raw = useId().replace(/:/g, '');
  const g0 = `paint0_${raw}`;
  const g1 = `paint1_${raw}`;
  const g2 = `paint2_${raw}`;
  const g3 = `paint3_${raw}`;
  const g4 = `paint4_${raw}`;
  const clip = `clip_${raw}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10.303 14.3529L8.99492 4.88011C8.79368 2.74109 8.49181 2.43552 8.29057 2.02809C8.08932 1.62066 5.97625 -0.212792 2.25322 1.00951C-1.74393 2.32181 3.76256 14.8622 4.36629 15.9826C4.97002 17.1031 8.08932 24.0294 12.1142 23.8257C16.1391 23.622 19.2584 20.4644 22.9814 15.3715C26.7045 10.2786 27.7107 8.34329 27.107 5.69498C26.48 2.94481 21.5727 2.63924 18.3528 2.2318C15.1329 1.82437 12.6173 1.62066 12.6173 2.02809C12.6173 2.43552 13.0198 2.60528 13.2211 2.74109C14.3279 3.42015 17.085 5.00234 19.2584 6.30613C21.9752 7.93586 22.8808 8.34329 22.9814 9.46373C23.0619 10.3601 21.8075 11.3311 21.1702 11.7046C19.1913 12.9346 15.0323 15.3085 14.2273 15.7789C13.2211 16.367 12.2148 16.8994 11.4099 16.5938C10.7659 16.3493 10.4036 14.998 10.303 14.3529Z"
        fill={`url(#${g0})`}
      />
      <path
        d="M12.1139 23.8257C16.1388 23.622 19.2581 20.4644 22.9812 15.3715C25.0351 12.5618 26.2622 10.7132 26.8482 9.17566C26.0779 10.7379 23.9492 11.8521 22.9812 12.2139L10.9065 18.5291L7.08033 20.5662C8.42271 22.346 10.1618 23.9245 12.1139 23.8257Z"
        fill={`url(#${g1})`}
      />
      <path
        d="M0.833588 3.35217C0.491203 7.39905 3.89877 15.1149 4.36629 15.9826C4.6772 16.5596 5.65527 18.6764 7.08061 20.5662L10.9067 18.529C9.39741 19.1402 8.29057 16.5937 7.08061 12.9268C6.13835 10.0071 4.90035 6.71813 4.36629 4.88005C3.86318 3.14846 3.46069 1.21315 2.1526 1.31501C1.10613 1.3965 0.837228 2.70707 0.833588 3.35217Z"
        fill="#4507E5"
      />
      <g clipPath={`url(#${clip})`} data-figma-skip-parse="true">
        <g transform="matrix(-0.0168039 0.016501 -0.00993835 -0.0103709 29.6878 0.81755)">
          <rect
            x="0"
            y="0"
            width="1156.86"
            height="974.589"
            fill={`url(#${g2})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1156.86"
            height="974.589"
            transform="scale(1 -1)"
            fill={`url(#${g2})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1156.86"
            height="974.589"
            transform="scale(-1 1)"
            fill={`url(#${g2})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1156.86"
            height="974.589"
            transform="scale(-1)"
            fill={`url(#${g2})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <path
        d="M21.0693 11.6211C19.0904 12.8511 14.9313 15.4287 14.1264 15.8992C13.6625 16.1702 13.1987 16.3862 12.7546 16.5103L10.8058 18.4456L22.8805 12.3158C23.8486 11.954 25.9773 10.6545 26.7475 9.09221C27.2238 7.84277 27.2767 6.79879 27.006 5.61151C26.3791 2.86134 21.4718 2.55577 18.2519 2.14834C15.032 1.7409 12.5164 1.53719 12.5164 1.94462C12.5164 2.35205 12.9189 2.52181 13.1201 2.65763C14.227 3.33668 16.984 4.91887 19.1575 6.22266C21.8743 7.85239 22.7799 8.25982 22.8805 9.38026C22.961 10.2766 21.7066 11.2477 21.0693 11.6211Z"
        fill={`url(#${g3})`}
      />
      <path
        d="M11.6111 14.1656V5.03664C11.6111 4.56293 12.1204 4.26932 12.5229 4.51107L19.9162 8.95219C20.3049 9.18568 20.3116 9.75283 19.9286 9.9957L12.5353 14.6836C12.1332 14.9385 11.6111 14.6459 11.6111 14.1656Z"
        fill={`url(#${g4})`}
      />
      <defs>
        <clipPath id={clip}>
          <path d="M21.0693 11.6211C19.0904 12.8511 14.9313 15.4287 14.1264 15.8992C13.6625 16.1702 13.1987 16.3862 12.7546 16.5103L10.8058 18.4456L22.8805 12.3158C23.8486 11.954 25.9773 10.6545 26.7475 9.09221C27.2238 7.84277 27.2767 6.79879 27.006 5.61151C26.3791 2.86134 21.4718 2.55577 18.2519 2.14834C15.032 1.7409 12.5164 1.53719 12.5164 1.94462C12.5164 2.35205 12.9189 2.52181 13.1201 2.65763C14.227 3.33668 16.984 4.91887 19.1575 6.22266C21.8743 7.85239 22.7799 8.25982 22.8805 9.38026C22.961 10.2766 21.7066 11.2477 21.0693 11.6211Z" />
        </clipPath>
        <linearGradient id={g0} x1="6.37874" y1="1.5188" x2="11.8317" y2="18.8989" gradientUnits="userSpaceOnUse">
          <stop stopColor="#49B7FF" />
          <stop offset="0.0830695" stopColor="#4EB7FF" />
          <stop offset="0.551609" stopColor="#4165FF" />
          <stop offset="1" stopColor="#4931FF" />
        </linearGradient>
        <linearGradient id={g1} x1="8.18967" y1="21.5848" x2="27.0104" y2="11.389" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4F6AFF" />
          <stop offset="0.238878" stopColor="#5B79FF" />
          <stop offset="1" stopColor="#3D49F6" />
        </linearGradient>
        <linearGradient id={g2} x1="0" y1="0" x2="500" y2="500" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A5D4FF" />
          <stop offset="0.725962" stopColor="#4784FF" />
          <stop offset="1" stopColor="#483CFF" />
        </linearGradient>
        <linearGradient id={g3} x1="13.9641" y1="2.16486" x2="14.1304" y2="4.98176" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4985FF" />
          <stop offset="1" stopColor="#4985FF" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={g4} x1="15.7366" y1="6.91722" x2="11.5321" y2="14.7177" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EAF3FD" />
          <stop offset="1" stopColor="#75A7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
